import React from "react";
import { useParams } from "react-router-dom";
import { IndicatorsPage } from "componentes/templates/indicatorsPage";



function View() {
  let { dsh, id } = useParams();

  //let url = "https://uio.correovirtual.com:8088/superset/dashboard/" + dsh + "/?idIndicador=" + id + "&&standalone=true";
  let url = "https://reports.oraotca.org/superset/dashboard/" + dsh + "/?idIndicador=" + id + "&standalone=2";


  return (
    <>

      <IndicatorsPage>
        <iframe title="Indicator" width="100%" height="1800" src={url} />
      </IndicatorsPage>


    </>
  );



}
export default View;